import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Mariana López',
  info: '32 años - Córdoba, Argentina',
  text: 'Antes improvisaba cada sesión y terminaba agotada. Con el Mega Pack, llego al consultorio con todo listo. Mis registros son claros y las familias notan la diferencia. Es lo mejor que compré en años.'
}, {
  name: 'Valentina Rojas',
  info: '28 años - Bogotá, Colombia',
  text: 'Trabajo con niños con TEA y siempre sentía que me faltaba estructura. Este sistema me dio exactamente eso: sesiones adaptadas, registros organizados y tranquilidad. Lo recomiendo al 100%.'
}, {
  name: 'Camila Fernández',
  info: '35 años - Santiago, Chile',
  text: 'Llevaba 8 años atendiendo y nunca había tenido un sistema así. Las planillas de seguimiento por etapa cambiaron mi forma de mostrar avances. Las familias ahora entienden el proceso.'
}, {
  name: 'Lucía Herrera',
  info: '30 años - Lima, Perú',
  text: 'Lo que más me ayudó fue la guía de sesiones complejas. Tengo pacientes con TDAH que se desregulan y antes no sabía cómo manejar esos momentos. Ahora tengo herramientas concretas.'
}, {
  name: 'Ana Paula Méndez',
  info: '27 años - Montevideo, Uruguay',
  text: 'Recién egresada y con mucha inseguridad clínica. Este pack me dio la estructura que la facultad no me dio. Siento que trabajo con más criterio y menos ansiedad.'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-white" data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-228">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-229">
            Lo que dicen otras colegas
          </h2>
          <div className="flex justify-center gap-1" data-id="element-230">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-231" />)}
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-232">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-50 p-8 rounded-xl relative hover:shadow-md transition-shadow" data-id="element-233">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-gray-200" data-id="element-234" />

              <div className="flex gap-1 mb-4" data-id="element-235">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-236" />)}
              </div>

              <p className="text-gray-700 mb-6 italic relative z-10" data-id="element-237">
                "{t.text}"
              </p>

              <div className="border-t border-gray-200 pt-4" data-id="element-238">
                <p className="font-bold text-gray-900" data-id="element-239">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-240">{t.info}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}